/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_ArchInputs */

const en_fc_dl_kind_arch = /** @type {(inputs: Fc_Dl_Kind_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arch Linux package`)
};

/**
* | output |
* | --- |
* | "Arch Linux package" |
*
* @param {Fc_Dl_Kind_ArchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_arch = /** @type {((inputs?: Fc_Dl_Kind_ArchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_ArchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_arch(inputs)
});
export { fc_dl_kind_arch as "fc.dl.kind.arch" }